import { IntraDayProfileDataItem } from './IntraDayProfileData';
import {
    generateGroupedBarSeries,
    generateScaledLineSeries,
} from 'utils/d3fc/chartSeries';

export const generateLineSeries = (
    dataSeries: IntraDayProfileDataItem[],
    selectFn: (d: IntraDayProfileDataItem) => number,
    yAxisDomain: [number, number],
    lineClass: string
) =>
    generateScaledLineSeries(dataSeries, selectFn, yAxisDomain, lineClass, [
        () => 0,
    ]);

export const generateVolumeBarSeries = (
    seriesLength: number,
    chartWidth: number,
    leftBarClass: string,
    rightBarClass: string
) =>
    generateGroupedBarSeries(
        seriesLength,
        chartWidth,
        [leftBarClass, rightBarClass],
        (d: IntraDayProfileDataItem) => d.barWidthPercentage
    );
